import { SUBMIT_CONTACT_FORM } from '../constants/ActionTypes';
import { getEndpointUrl } from '../config';

export const sendContactForm = (parameters) => ({
	type: SUBMIT_CONTACT_FORM,
	payload: {
		client: 'accountService',
		url: getEndpointUrl('contact'),
		method: 'POST',
		data: parameters,
	},
});
